import { useEffect } from "react";
import { Button, Icon } from "@sellar-io/components";
import { useMenuDrawerContext } from "../../../components/menu/MenuDrawerContextProvider.shared";
import { useNavigate } from "react-router";
import { SELLAR_CREDIT_TAB } from "../../../constants/routes";
import { Alert } from "../../../components/alert/Alert";
import {
  SELLAR_CREDIT_ONBOARDING_SOURCE_KEY,
  SELLAR_CREDIT_ONBOARDING_SOURCE_VALUE,
} from "~/constants/sellarConstants.shared";

const goCardlessLink = "https://pay.gocardless.com/BRT0002MD97VH03";

export const TwoDirectDebitRegistrationPage = () => {
  const navigate = useNavigate();

  const source = new URLSearchParams(window.location.search).get(
    SELLAR_CREDIT_ONBOARDING_SOURCE_KEY,
  );

  const isFromSellarCreditOnboarding =
    source === SELLAR_CREDIT_ONBOARDING_SOURCE_VALUE;

  const { setDisplayTypeOverride } = useMenuDrawerContext();

  useEffect(() => {
    setDisplayTypeOverride("hidden");
  }, [setDisplayTypeOverride]);

  const onBackToTab = () => {
    setDisplayTypeOverride("sticky");
    navigate(`${SELLAR_CREDIT_TAB}?provider=two`);
  };

  const onVisitGoCardlessLink = () => {
    window.open(goCardlessLink, "_blank", "noopener noreferrer");
    setDisplayTypeOverride("sticky");
    navigate(`${SELLAR_CREDIT_TAB}?provider=two`);
  };

  return (
    <div className="flex flex-col items-center p-6">
      <div className="flex max-w-[800px] flex-col items-center">
        <img
          src="https://sellar.imgix.net/sellar-image-assets/sellar-credit/sellar-credit-account-set-up.png"
          className="mx-auto mb-9 w-[236px]"
          width={236}
          height={24}
        />
        <h1 className="mb-4 text-2xl font-semibold">
          Set up your Direct Debit
        </h1>
        <p className="mb-8 text-center text-gray-600">
          If you haven't done so already, provide your bank account details on
          the following <span className="font-bold">secure</span> page to
          complete your Direct Debit set up for Two Ltd (UK).
        </p>

        <div className="mb-8 flex w-full items-center gap-4 rounded-lg border border-zinc-200 bg-white p-4">
          <div className="flex w-fit items-center justify-center rounded-lg bg-zinc-100 p-3">
            <Icon icon="CARD_ID_OUTLINE" className="text-black" size={1.2} />
          </div>
          <div>
            <p className="font-semibold">What you will need</p>
            <p>
              You will need your company's bank details, and your
              <strong> Sellar login email</strong>.
            </p>
          </div>
        </div>

        <Alert
          type="information"
          title="Important"
          message="You won't be notified if you already have an existing direct debit set up with Two, so make sure that you or someone else in your company hasn’t already set one up before proceeding"
          className="mb-8"
        />

        <div className="flex w-full flex-1 flex-col justify-between gap-2 sm:flex-row">
          <Button
            type="button"
            color="secondary"
            className="w-full text-zinc-600"
            onClick={onBackToTab}
          >
            {isFromSellarCreditOnboarding ? "SKIP FOR NOW" : "BACK TO TAB"}
          </Button>
          <Button onClick={onVisitGoCardlessLink} className="w-full">
            <>
              <Icon icon="LOCK" size={1} className="text-white" /> Continue To
              Secure Setup
            </>
          </Button>
        </div>
        {isFromSellarCreditOnboarding && (
          <p className="mt-4 text-center text-sm text-gray-600">
            You can always set up your direct debit later from your Sellar
            Credit tab
          </p>
        )}
      </div>
    </div>
  );
};
